import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

const InvisibleSelect = ({ value, label, name, itemList = [], onChange }) => {
  return (
    <FormControl
      sx={{ m: 1, width: 'calc(100% - 16px)' }}
      size="small"
    >
      <InputLabel id={name}>{label}</InputLabel>
      <Select
        sx={{ boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: 0 } }}
        name={name}
        value={value}
        onChange={onChange}
        labelId={name}
        label={label}
      >
        <MenuItem value={''} selected={false}><em>None</em></MenuItem>
        {
          itemList.map((item, index) => (
            <MenuItem key={index} value={index}>{item}</MenuItem>
          ))
        }
      </Select>
    </FormControl>
  )
}

export default InvisibleSelect;